export default "__VITE_ASSET__4183f986__"